function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "37",
  height: "29",
  viewBox: "0 0 37 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.78 19.233H6.735l-5.02-8.7 5.02-8.699H16.78l5.02 8.7-5.02 8.699zm-9.161-1.53h8.277l4.14-7.17-4.14-7.17H7.62l-4.14 7.17 4.14 7.17z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.496 27.165H20.455L15.43 18.47l5.024-8.7h10.044l5.021 8.7-5.024 8.696zm-9.16-1.529h8.277l4.14-7.17-4.137-7.167h-8.28l-4.138 7.17 4.137 7.167z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.29 13.133a2.6 2.6 0 100-5.199 2.6 2.6 0 000 5.199z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.808 21.068a2.6 2.6 0 100-5.198 2.6 2.6 0 000 5.198z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.29 29a2.6 2.6 0 100-5.198 2.6 2.6 0 000 5.198z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.92 29a2.599 2.599 0 100-5.198 2.599 2.599 0 000 5.198z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.456 13.133a2.6 2.6 0 100-5.198 2.6 2.6 0 000 5.198z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.84 21.101a2.6 2.6 0 100-5.198 2.6 2.6 0 000 5.198z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.466 21.101a2.6 2.6 0 100-5.198 2.6 2.6 0 000 5.198z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.311 5.198a2.6 2.6 0 100-5.198 2.6 2.6 0 000 5.198z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.466 5.198a2.6 2.6 0 100-5.198 2.6 2.6 0 000 5.198z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.6 13.133a2.6 2.6 0 10-.001-5.198 2.6 2.6 0 000 5.198z",
  fill: "#fff"
})));